import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
// css
import styles from "./ClientDetail.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";
import { APPOINTMENT_EDIT, APPOINTMENT_FORMS_VIEW, CHATTER_LESSON_EDIT, CHATTER_LESSON_LIST, CLIENT_ASSIGNED_COSNENT_FORMS_VIEW, MANAGE_PARENTS_EDIT, MANAGE_PARENTS_LIST, THERAPIST_DETAIL } from "config/paths";
import { useChatterLessonDetailsQuery } from "store/services/chatter/lesson";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useDeleteAppointmentMutation, useGetAppointmentClientsListQuery, useGetParentAppointmentsListQuery } from "store/services/appointment";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { convertToMomentDate, successMessageToast, userFullName } from "helpers/common";
import { CommonToolTip, CstmPagination, NoRecordFound } from "components/Common/Common";
import { CheckIcon, DeleteIcon, EditIcon, PlusCircleIcon, ViewDocumentIcon } from "Assets/icons";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { APPOINTMENT_SESSION_TYPE_OPTIONS, CONSENT_FORM_STATUS_OPTIONS } from "config/constants";
import { useAssignConsentChecklistsMutation, useDeleteAssignedConsentFormMutation, useDeleteConsentCheckListsMutation, useGetAssignedConsentFormsListQuery, useGetConsentAssignedCheckListsQuery, useGetConsentCheckListsQuery, useGetGuardianAndChildConsentDetailsQuery, useGetGuardianClientDocumentsQuery, useUpdateAssignedConsentFormStatusMutation } from "store/services/guardian";
import AddConsentFormsModal from "components/Modals/AddConsentFormPop";
import ConsentCheckListsModal from "components/Modals/ConsentChecklistsModal";
import ViewAttachments from "pages/SideTabPages/ManageSupportStaff/TaskSessionView/ViewAttachments";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import { Formik } from "formik";
import moment from "moment";
import { ManageReceipts } from "./Receipts";
import AddChecklistPop from "components/Modals/AddChecklistPop";
import { ManageResources } from "./Resources";
import { ManageDocuemnts } from "./Documents";

const ConsentForms = () => {
  const lessonId = 100
  const { id, parentId } = useParams();
  const navigate = useNavigate();
  const lessonDetails = [{}, {}]
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 10
  const [filter, setFilter] = useState({ search: "", appointment_type: "", status: "active" })
  const [modalType, setModalType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [consentModal, setConsentModal] = useState(false)
  const [checkListModal, setCheckListModal] = useState(false)
  const [initialValues, setInitialValues] = useState({ checklists: [] })

  const { data: consentForms, isLoading, isFetching, isError } = useGetAssignedConsentFormsListQuery({ clientId: id, parentId, ...filter, page: currentPage, limi: pageSize });
  const totalRecords = consentForms?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const [deleteConsentForm, { isLoading: deleteConsentFormLoading }] = useDeleteAssignedConsentFormMutation();
  const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

  const { data: checkLists, isLoading: checkListsLoading, isFetching: checkListsFetching } = useGetConsentCheckListsQuery({ page: 1, limit: 1000, id, parentId });
  const { data } = useGetGuardianAndChildConsentDetailsQuery({ clientId: id, parentId })
  const clientDetails = data?.clientDetails
  const parentDetails = data?.parentDetails
  const { data: assignedCheckLists, isLoading: assignedCheckListsLoading, isFetching: assignedCheckListsFetching } = useGetConsentAssignedCheckListsQuery({ clientId: id, parentId })
  const [assignNewCheckList, { isLoading: assignNewCheckListLoading }] = useAssignConsentChecklistsMutation()
  const [deleteCheckList, { isLoading: deleteCheckListLoading }] = useDeleteConsentCheckListsMutation()
  const [updateConsentStatus, { isLoading: updateConsentStatusLoading }] = useUpdateAssignedConsentFormStatusMutation()

  const handleCheckSubmit = async (status, id) => {
    const body = {
      status,
    }
    try {
      const result = await assignNewCheckList({ body, id }).unwrap()
      successMessageToast(result?.message)
      setShow(false);
    } catch (error) {
      console.log("error assigning consent form", error)
    }
  }
  const handleSubmit = () => {

  }
  useEffect(() => {
    if (assignedCheckLists) {
      setInitialValues({ checklists: assignedCheckLists?.map((item) => item?.id) })
    }
    else {
      setInitialValues({ checklists: [] })
    }
  }, [assignedCheckLists])

  const column = [
    {
      head: "Title",
      accessor: "title",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{item?.formAssignedtoClient?.title || "--"}</h6>
      ),
    },
    {
      head: "Description",
      accessor: "description",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{item?.formAssignedtoClient?.description || "--"}</h6>
      ),
    },

    {
      head: "Submission Status",
      accessor: "status",
      // sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <p
          style={{ width: 80 }}
          className={`${item.status == "submitted"
            ? "greenStatus" : item.status == "pending" ? "yellowStatus"
              : "redStatus"
            } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
        >
          {item?.status}
        </p>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      // sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <div
          onClick={(e) => e.stopPropagation()}
        >
          <Dropdown onSelect={(e) => handleSelectConsentStatus(e, item?.id)}>
            <Dropdown.Toggle
              disabled={item.status == "pending"}
              className="border-light text-dark w-100 fw-sbold"
              style={{ background: "#F3F3F3", height: 40, display: "flex" }}
              id="dropdown-basic"
            >
              <h6> {CONSENT_FORM_STATUS_OPTIONS?.find(x => x.value === item?.verify)?.label || "Select Status"}{" "}</h6>
              <span className="icn ms-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="5"
                  viewBox="0 0 10 5"
                  fill="none"
                >
                  <path
                    d="M4.99997 4.27048L0.816406 0.0869141H9.18353L4.99997 4.27048Z"
                    fill="#1C1B1F"
                  />
                </svg>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="w-100"
            >
              {
                CONSENT_FORM_STATUS_OPTIONS?.map((item, index) => {
                  return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                })
              }
            </Dropdown.Menu>
          </Dropdown>
        </div >
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          {/* <CommonToolTip
            text={"Checlist"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={() => { setCurrentEntry(item); setCheckListModal(true) }}
            >
              <CheckIcon />
            </Button>}
          /> */}
          {
            item?.status != "submitted" &&
            <CommonToolTip
              text={"Delete"}
              component={<Button
                disabled={item?.status == "submitted"}
                className="p-0"
                variant="transparent"
                type="button"
                onClick={() => {

                  setCurrentEntry(item);
                  setModalType("delete");
                  setShowModal(true);
                }}
              >
                <DeleteIcon />
              </Button>}
            />
          }
          <CommonToolTip
            text={"View"}
            component={<Button
              onClick={() => {
                navigate(generatePath(CLIENT_ASSIGNED_COSNENT_FORMS_VIEW, { id: item?.id }))
              }} className="p-0"
              variant="transparent"
              type="button"
            >
              <ViewDocumentIcon />
            </Button>}
          />
        </div>
      ),
    },
  ]

  const resetFilter = () => {
    setFilter({ search: "", appointment_type: "", status: "active" });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter({ ...filter, [key]: value })
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleDeleteAppointment = async () => {
    try {

      setShowModal(false);

      // const list = [...therapistProfiles];
      // const index = therapistProfiles?.findIndex(x => x.id === currentEntry?.id);
      // delete list[index];
      // setTherapistProfiles(list.filter(Boolean));

      const response = await deleteConsentForm({ id: currentEntry?.id }).unwrap();
      console.log('result response', response)
      successMessageToast(response?.message);

    } catch (err) {
      console.log("error deleting appointment", err);
    }
  };

  const handleDeleteCheckList = async () => {
    try {

      setShowModal(false);

      // const list = [...therapistProfiles];
      // const index = therapistProfiles?.findIndex(x => x.id === currentEntry?.id);
      // delete list[index];
      // setTherapistProfiles(list.filter(Boolean));

      const response = await deleteCheckList({ id: currentEntry?.id }).unwrap();
      console.log('result response', response)
      successMessageToast(response?.message);

    } catch (err) {
      console.log("error deleting appointment", err);
    }
  };

  const handleSelectConsentStatus = async (status, id) => {
    const body = {
      verify: status
    }
    console.log('body', body)
    try {
      const result = await updateConsentStatus({ body, id }).unwrap()
      successMessageToast(result?.message)
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleViewPdf = async (name) => {

    try {
      const url = await getFileUrl(name).unwrap();
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  };
  const [checkListPop, setCheckListPop] = useState(false)
  return (
    <>
      <AddChecklistPop show={checkListPop} setShow={setCheckListPop} />
      <AddConsentFormsModal show={consentModal} setShow={setConsentModal} parentId={parentId} clientId={id} clientType={clientDetails?.client_detail?.client_type} />
      {/* <ConsentCheckListsModal show={checkListModal} setShow={setCheckListModal} consentId={currentEntry?.id} checkLists={currentEntry?.checklists} /> */}
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={modalType == "delete" ? handleDeleteAppointment : handleDeleteCheckList}
        type={modalType}
      />
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        {(isFetching || updateConsentStatusLoading || deleteCheckListLoading || assignNewCheckListLoading || getFileFetching || checkListsFetching || assignedCheckListsFetching) && (!isLoading || !getFileLoading || !assignedCheckListsLoading || !checkListsLoading) && <LoadingOverlay />}
        <Container fluid={true}>
          {
            isLoading || getFileLoading || assignedCheckListsLoading || checkListsLoading ? <LoadingIndicator /> :
              <Row>
                <Col
                  lg="12"
                  className=""
                  style={{ borderRight: "1px solid #3da0aa4f" }}
                >
                  <div className="left my-3 ">
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                      <li className="">
                        <Link
                          className="themeBlue fw-sbold back-to-btn"
                          to={`/manage-parents/details/${parentId}`}
                        >
                          <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                          </svg> Back
                        </Link>
                      </li>
                      <li className="">
                        <Link
                          className="themeBlue fw-sbold"
                          style={{ textDecoration: "underline" }}
                          to={`/manage-parents/details/${parentId}`}
                        >
                          Parents Details
                        </Link>
                      </li>
                      <li className="">
                        <h5 className="m-0 fw-bold themeBlue">/ Client Details</h5>
                      </li>
                    </ul>
                  </div>
                  <Row>
                    <Col lg="6" className="mb-2">
                      <Row>
                        <Col lg="12" className="my-2">
                          <div className="top d-flex align-items-center gap-10">
                            <div
                              className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                              style={{ height: 35, width: 35, background: "#DBDBDB" }}
                            >
                              {data?.clientDetails?.firstname?.[0]?.toUpperCase() + data?.clientDetails?.lastname[0]?.toUpperCase()}
                            </div>
                            <div className="content">
                              <h6 className="m-0 themeBlue fw-sbold text-capitalize">{userFullName(clientDetails)}</h6>
                            </div>
                          </div>
                          <Row>
                            <Col md="4" sm="6" className="my-2">
                              <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                <h6 className="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span className="" style={{ color: "#3DA0AA" }}>
                                    ■
                                  </span>{" "}
                                  DOB
                                </h6>
                                <p style={{ fontSize: "14px" }} className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.dob ? moment(clientDetails?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</p>
                              </div>
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                <h6 className="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span className="" style={{ color: "#3DA0AA" }}>
                                    ■
                                  </span>{" "}
                                  Gender
                                </h6>
                                <p style={{ fontSize: "14px" }} className="m-0 themeBlue pt-2 text-capitalize">{clientDetails?.client_detail?.gender || "--"}</p>
                              </div>
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                <h6 className="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span className="" style={{ color: "#3DA0AA" }}>
                                    ■
                                  </span>{" "}
                                  City/Town
                                </h6>
                                <p style={{ fontSize: "14px" }} className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.city_town || "--"}</p>
                              </div>
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                <h6 className="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span className="" style={{ color: "#3DA0AA" }}>
                                    ■
                                  </span>{" "}
                                  Client Type
                                </h6>
                                <p style={{ fontSize: "14px" }} className="m-0 themeBlue pt-2 text-capitalize">{clientDetails?.client_detail?.client_type || "--"}</p>
                              </div>
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                <h6 className="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span className="" style={{ color: "#3DA0AA" }}>
                                    ■
                                  </span>{" "}
                                  Parent
                                </h6>
                                <p style={{ fontSize: "14px" }} className="m-0 themeBlue pt-2 text-capitalize">{userFullName(parentDetails) || "--"}</p>
                              </div>
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                <h6 className="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span className="" style={{ color: "#3DA0AA" }}>
                                    ■
                                  </span>{" "}
                                  Parent Email
                                </h6>
                                <p style={{ fontSize: "14px" }} className="m-0 themeBlue pt-2">{parentDetails?.email || "--"}</p>
                              </div>
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                <h6 className="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span className="" style={{ color: "#3DA0AA" }}>
                                    ■
                                  </span>{" "}
                                  Parent Phone
                                </h6>
                                <p style={{ fontSize: "14px" }} className="m-0 themeBlue pt-2">{parentDetails?.phone || "--"}</p>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        {
                          isLoading ? <LoadingIndicator /> :
                            <Col lg="12" className="my-4">
                              <div className="TableFilter d-flex align-items-end justify-content-between gap-10  ">
                                <div className="left">
                                  <TableHeader
                                    heading={"Assigned Consent Forms"}
                                    hideStatusFilter
                                    handleFilterChange={handleFilterChange}
                                    resetFilter={resetFilter}
                                    filter={filter}
                                    searchPlaceholder="Last, First Name, Email"
                                  >
                                  </TableHeader>
                                </div>
                                <div className="right">
                                  <ul style={{ marginBottom: "13px" }} className="list-unstyled ps-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                    <li className="">
                                      <Link
                                        // to={MANAGE_STATUS_ADD}
                                        onClick={() => setConsentModal(true)}
                                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                      >
                                        <span className="icn me-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="19"
                                            height="19"
                                            viewBox="0 0 19 19"
                                            fill="none"
                                          >
                                            <mask
                                              id="mask0_0_4440"
                                              style={{ maskType: "alpha" }}
                                              maskUnits="userSpaceOnUse"
                                              x="0"
                                              y="0"
                                              width="19"
                                              height="19"
                                            >
                                              <rect
                                                width="18.7197"
                                                height="18.7197"
                                                fill="#D9D9D9"
                                              />
                                            </mask>
                                            <g mask="url(#mask0_0_4440)">
                                              <path
                                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                                fill="white"
                                              />
                                            </g>
                                          </svg>
                                        </span>{" "}
                                        Add Consent Form
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <Row>

                                <div className="table-outer">
                                  {isLoading ? (
                                    <div style={{ height: "200px" }}>
                                      <LoadingIndicator />
                                    </div>
                                  ) : isError ? (
                                    <ErrorComponent />
                                  ) : (
                                    <>
                                      {(isFetching || deleteConsentFormLoading) && (
                                        <LoadingOverlay />
                                      )}
                                      <TableLayout data={consentForms?.records} column={column} />
                                    </>
                                  )}
                                  <CstmPagination
                                    totalPages={totalPages}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                  />
                                </div>

                              </Row>
                            </Col>
                        }
                      </Row>
                    </Col>
                    <Col lg="6" className="mb-3" style={{ borderLeft: "1px solid #41a2a84d " }}>
                      <Row>
                        <Col lg="12">
                          <Formik
                            initialValues={initialValues}
                            // validationSchema={appointmentsValidationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize
                          >
                            {({
                              handleSubmit, values, setFieldValue, errors
                            }) => (
                              <Form onSubmit={handleSubmit}>
                                <div
                                  className="py-3"
                                //   style={{ borderTop: "1px solid #41a2a84d" }}
                                >
                                  <Row>
                                    {
                                      <Col md="12" sm="4">
                                        <div className="TableFilter d-flex justify-content-between align-items-center">
                                          <div className="left">
                                            <h5 className="m-0 fw-bold pb-2 mb-3">Checklists</h5>
                                          </div>
                                          <div className="right">
                                            <ul style={{ marginBottom: "13px" }} className="list-unstyled ps-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                              <li className="">
                                                <Link
                                                  // to={MANAGE_STATUS_ADD}
                                                  onClick={() => setCheckListPop(true)}
                                                  className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                                >
                                                  <span className="icn me-1">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="19"
                                                      height="19"
                                                      viewBox="0 0 19 19"
                                                      fill="none"
                                                    >
                                                      <mask
                                                        id="mask0_0_4440"
                                                        style={{ maskType: "alpha" }}
                                                        maskUnits="userSpaceOnUse"
                                                        x="0"
                                                        y="0"
                                                        width="19"
                                                        height="19"
                                                      >
                                                        <rect
                                                          width="18.7197"
                                                          height="18.7197"
                                                          fill="#D9D9D9"
                                                        />
                                                      </mask>
                                                      <g mask="url(#mask0_0_4440)">
                                                        <path
                                                          d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                                          fill="white"
                                                        />
                                                      </g>
                                                    </svg>
                                                  </span>{" "}
                                                  Add New Checklist
                                                </Link>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>

                                        <div className="d-flex flex-column gap-2">
                                          {checkLists?.records?.length ? checkLists?.records?.map((item, index) => {
                                            const isChecked = values.checklists?.includes(item.id);

                                            return (
                                              <div
                                                key={item.id}
                                                className="d-flex align-items-center gap-3 p-2 rounded shadow-sm bg-light checklist-item"
                                                style={{ cursor: "pointer", transition: "all 0.3s ease" }}
                                                onClick={() => {
                                                  handleCheckSubmit(item?.status === "checked" ? "unchecked" : "checked", item?.id);
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  checked={item?.status === "checked"}
                                                  onChange={(e) => {
                                                    e.stopPropagation();
                                                    let newChecklist = [...(values.checklists || [])];
                                                    if (e.target.checked) {
                                                      newChecklist.push(item.id);
                                                    } else {
                                                      newChecklist = newChecklist.filter(id => id !== item.id);
                                                    }
                                                    setFieldValue("checklists", newChecklist);
                                                  }}
                                                  style={{ height: 20, width: 20, accentColor: "#b46c9f" }}
                                                />
                                                <p className="mb-0 text-dark fw-medium" style={{ fontSize: "15px" }}>
                                                  {item?.title}
                                                </p>

                                                <div className="ms-auto">
                                                  <CommonToolTip
                                                    text="Delete"
                                                    component={
                                                      <Button
                                                        disabled={item?.status === "submitted"}
                                                        className="p-0"
                                                        variant="transparent"
                                                        type="button"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          setCurrentEntry(item);
                                                          setModalType("checkList");
                                                          setShowModal(true);
                                                        }}
                                                      >
                                                        <DeleteIcon />
                                                      </Button>
                                                    }
                                                  />
                                                </div>
                                              </div>

                                            );
                                          }) : <NoRecordFound />}
                                        </div>
                                      </Col>

                                    }
                                  </Row>
                                </div>
                                <Row>
                                  <Col className="my-2" lg="12">
                                    <div
                                      className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                    // style={{ borderTop: "1px solid #41a2a84d" }}
                                    >
                                      {/* <Button type="submit" disabled={assignCheckListLoading} className="d-flex align-items-center justify-content-center commonBtn">
                                        {assignCheckListLoading ? <LoadingIndicator inline /> : "Save"}

                                      </Button> */}
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            )}
                          </Formik>
                        </Col>
                        {/* <Col lg="12" className="my-2">
                          <ViewAttachments
                            scroller={true}
                            attachments={attachments?.records}
                            handleViewPdf={handleViewPdf}
                            title={"Documents :"}
                          />
                        </Col> */}
                        <Col lg="12" className="my-2">
                          <ManageDocuemnts />
                        </Col>
                        <Col lg="12" className="my-2">
                          <ManageReceipts />
                        </Col>
                        <Col lg="12" className="my-2">
                          <ManageResources />
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </Col>
              </Row>
          }
        </Container>
      </section>
    </>
  );
};

export default ConsentForms;
